import { render, staticRenderFns } from "./digitalizacion.vue?vue&type=template&id=01662df7&"
import script from "./digitalizacion.vue?vue&type=script&lang=js&"
export * from "./digitalizacion.vue?vue&type=script&lang=js&"
import style0 from "./digitalizacion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports